module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.startTime')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "32%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.title')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.creator')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.slot.counts')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.slot.counts.available')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.missions), function(mission) {
    return _c('mission-list-row', {
      key: mission.uid,
      attrs: {
        "mission": mission
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missions.length >= 10),
      expression: "missions.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.startTime')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "32%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.title')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.creator')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.slot.counts')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.slot.counts.available')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-023d8878"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionListTable.vue
// module id = 464
// module chunks = 0